<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '760px', maxWidth: '98vw' }"
  (onHide)="close()">

  <ng-template pTemplate="header"></ng-template>

  <div class="modal-body">
    <div class="modal-header-content">
      <img src="assets/img/logo-ftcloud-ia.svg" class="modal-header-logo" alt="FT Pilot IA" />
      <span class="modal-header-title">{{ 'tokenPurchase.header.line1' | transloco }}</span>
      <span class="modal-header-title">{{ 'tokenPurchase.header.line2' | transloco }}</span>
    </div>

    <div *ngIf="loading" class="loading-wrapper">
      <p-progressSpinner styleClass="package-spinner" strokeWidth="4" />
    </div>

    <div *ngIf="!loading && packages.length === 0" class="packages-empty">
      {{ 'tokenPurchase.empty' | transloco }}
    </div>

    <div *ngIf="!loading && packages.length > 0" class="packages-grid">
      <div *ngFor="let pkg of packages" class="package-card">
        <h3 class="package-name">{{ pkg.name }}</h3>
        <p class="package-desc" *ngIf="pkg.description">{{ pkg.description }}</p>
        <div class="package-price">{{ formatPrice(pkg) }}</div>
        <p-button
          [label]="'tokenPurchase.buyBtn' | transloco"
          icon="pi pi-shopping-cart"
          iconPos="right"
          [outlined]="true"
          styleClass="package-buy-btn"
          [loading]="buyingPackageId === pkg.packageId"
          [disabled]="buyingPackageId !== null"
          (onClick)="buyPackage(pkg)" />
      </div>
    </div>

    <div *ngIf="purchaseError" class="checkout-error">
      <i class="pi pi-exclamation-circle"></i> {{ purchaseError }}
    </div>
  </div>
</p-dialog>
